module.exports = __webpack_public_path__ + "img/fylke-1.eebb4328.svg";